export * from 'shared/config/default.config';
export * from 'shared/config/fonts.config';
export * from 'shared/config/score.config';
export * from 'shared/config/dropProduct.config';
export * from 'shared/config/mechanics.config';
export * from 'shared/config/levels.config';
export * from 'shared/config/map.config';
export * from 'shared/config/DP_content.config';
export * from 'shared/config/setting.config';
export * from 'shared/config/build.config';
export * from 'shared/config/htmlImage.config';
